// test879
(879 && 0);
